import { computed, watch } from 'vue'

import { useAuth } from '@common/auth-layer/composables/useAuth'
import { useCurrentUser } from '@common/current-user-layer/composables/useCurrentUser'
import { Theme, useTheme } from '@common/theme-layer/composables/useTheme'

export default defineNuxtPlugin(() => {
  // disable theme sync for now
  return void 0

  const authStore = useAuth().store
  const currentUser = useCurrentUser()
  const { getStoredTheme, setTheme } = useTheme()

  const resolvedThemePreference = computed<Theme>(() => {
    const darkMode = currentUser.store?.profile?.darkMode

    if (authStore.isLoggedIn && darkMode !== undefined) {
      return darkMode ? Theme.DARK : Theme.LIGHT
    }

    return getStoredTheme()
  })

  watch(
    resolvedThemePreference,
    theme => {
      void setTheme(theme, false)
    },
    { immediate: true }
  )
})
